<template>
  <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery" ref="queryForm" :model="queryParam">
            <a-row :gutter="24">
              <a-col :md="6" :sm="12">
                <a-form-item :label="this.language['system.user.nameOrWorkNo']">
                  <a-input :placeholder="this.language['common.pleaseInput']+this.language['system.user.nameOrWorkNo']" v-model="queryParam.username"></a-input>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="12">
                <a-form-item :label="this.language['portal.personalName']">
                  <a-input :placeholder="this.language['common.pleaseInput']+this.language['portal.personalName']" v-model="queryParam.realname" allowClear></a-input>
                </a-form-item>
              </a-col>


              <a-col :md="6" :sm="12" v-if="applicationVisible">
                <a-form-item :label="this.language['eletronicSigned.affiliationApplication']">
                  <a-select v-model="queryParam.appid" allowClear >
                    <a-select-option v-for="(application,index) in applicationList" :key="index.toString()" :value="application.id">
                      {{ application.applicationNameLanguage||application.applicationName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="10" :lg="11" :md="12" :sm="24">
                <a-form-item :label="this.language['user.apply.time']">
                  <j-date :placeholder="language['common.chooseStartDate']" :showTime="false" dateFormat="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.startTime"></j-date>
                  <span class="query-group-split-cust"></span>
                  <j-date :placeholder="language['common.chooseEndDate']" :showTime="false"  dateFormat="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.endTime"></j-date>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="6" :sm="12">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
                  <a-button  type="primary"  @click="resetQueryCondition" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
                </span>
              </a-col>
            </a-row>


          </a-form>

        </div>
        <!-- 查询区域-END -->





        <!-- 操作按钮区域 -->

        <!-- table区域-begin -->
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> &nbsp;
          </div>

          <a-table
            ref="table"
            size="middle"
            :scroll="{x:1500}"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">


            <span slot="action" slot-scope="text, record">
               <span v-if="record.maxCreateTime==record.createTime">
              <!--未处理、未绑定-->
              <span v-if="record.auditStatus=='approving'&&record.relationId==null">
                   <a @click="binding(record)">{{language['system.bind']}}</a>
                  <a-divider type="vertical" />
                   <a @click="refuse(record)">{{ language['common.reject'] }}</a>
              </span>
              <!--未处理、已绑定-->
              <span v-if="record.auditStatus=='approving'&&record.relationId!=null">
                   <a @click="chooseRole(record)">{{ language['column.userRole.choose'] }}</a>
                  <a-divider type="vertical" />
                <a-popconfirm :title="language['system.unbind.warn']" @confirm="unbound(record)" :okText="language['common.determineButton']" :cancelText="language['common.cancel']">
                            <a >{{ language['system.unbound'] }}</a>
                 </a-popconfirm>
                 <a-divider type="vertical" />
                 <a-popconfirm :title="language['system,cancel.warn']" @confirm="updateStatus(record)" :okText="language['common.determineButton']" :cancelText="language['common.cancel']">
                  <a >{{language['common.cancel']}}</a>
                 </a-popconfirm>
              </span>


              <!--已处理、已绑定-->
              <span v-if="(record.auditStatus=='approved'||record.auditStatus=='rejected')&&record.relationId!=null">
               <a @click="chooseRole(record)">{{ language['column.userRole.choose'] }}</a>
               <a-divider type="vertical" />
              <a-popconfirm :title="language['system.unbind.warn']" @confirm="unbound(record)" :okText="language['common.determineButton']" :cancelText="language['common.cancel']">
                            <a >{{ language['system.unbound'] }}</a>
              </a-popconfirm>

              </span>



              <!--已处理、未绑定-->
              <span v-if="(record.auditStatus=='approved'||record.auditStatus=='rejected')&&record.relationId==null">
               <a @click="binding(record)">{{ language['system.bind'] }}</a>
              </span>









              <!--              <span>-->
<!--                  <a @click="chooseRole(record)">角色分配</a>-->
<!--                  <a-divider type="vertical" />-->
<!--                   <a @click="binding(record)">绑定</a>-->
<!--                  <a-divider type="vertical" />-->
<!--                   <a @click="refuse(record)">拒绝</a>-->
<!--                  <a-divider type="vertical" />-->
<!--                   <a-popconfirm title="确定解绑吗？" @confirm="updateStatus(record)" okText="确定" cancelText="取消">-->
<!--                        <a >取消</a>-->
<!--                   </a-popconfirm>-->
<!--                 <a-divider type="vertical" />-->
<!--                </span>-->

<!--              <span>-->
<!--                <a-popconfirm title="确定解绑吗？" @confirm="unbound(record)" okText="确定" cancelText="取消">-->
<!--                  <a >解绑</a>-->
<!--                </a-popconfirm>-->

<!--                  <a-divider type="vertical" />-->
<!--                   <a @click="handleEdit(record)">绑定</a>-->
<!--                  <a-divider type="vertical" />-->
<!--                   <a @click="handleEdit(record)">拒绝</a>-->
<!--                 <a-divider type="vertical" />-->
<!--                </span>-->


             </span>
        </span>
          </a-table>
        </div>
<!--       <user-modal></user-modal>-->
    <user-apply-audit-modal ref="modalForm" @ok="modalFormOk"></user-apply-audit-modal>

  </a-card>
</template>

<script>
import {httpAction} from '@/api/manage'
import '@/assets/less/TableExpand.less'
import {mixinDevice} from '@/utils/mixin'
import {JeecgListMixin} from '@/mixins/JeecgListMixin'
import UserApplyAuditModal  from './UserApplyAuditModal'
import store from '@/store/'
export default {
  name: 'checkList',
  mixins:[JeecgListMixin, mixinDevice],
  props:{
    handleStatus:Number
  },
  components: {
   UserApplyAuditModal
  },
  data () {
    return {
      description: '用户应用授权管理页面',
      url: {
        list: "/sys/sysUserApplicationApply/queryCheckListForRecords",
        unbound:"/sys/sysUserApplicationApply/unbound",
        updateStatus:"/sys/sysUserApplicationApply/updateStatus"
      },

      queryParam: {
        handleStatus:this.handleStatus,
      },
      dictOptions:{},
      superFieldList:[],
      applicationList:{},
      previewVisible: false,
      applicationVisible:true
    }
  },
  created() {

    let applicationCode=this.$store.getters.applicationCode;
    if(applicationCode!="platform"){
      this.applicationVisible=false;
    }

    //   let  lanCode=    this.$i18n.locale
    // console.log("lanCode============",lanCode)
    this.getApplicationList();
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    columns() {
      if (this.language) {
        if(this.handleStatus == 0){
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            fixed: 'left',
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          // {
          //   title:"id",
          //   align:"center",
          //   dataIndex: 'id',
          //   width: 180
          // },
          {
            title:this.language['system.user.name'],
            ellipsis:true,
            align:"center",
            dataIndex: 'sysUser.username',
            width: 180
          },
          {
            title:this.language['portal.personalWorkNo'],
            width: 180,
            align:"center",
            dataIndex: 'sysUser.workNo'

          },
          {
            title:this.language['portal.personalName'],
            width: 200,
            ellipsis:true,
            align:"center",
            dataIndex: 'sysUser.realname'
          },
          {
            title:this.language['system.apply.application'],
            ellipsis:true,
            width:200,
            align:"center",
            dataIndex: 'bmApplication.applicationNameLanguage'
          },
          {
            title:this.language['user.apply.description'],
            width: 200,
            ellipsis:true,
            align:"center",
            dataIndex: 'bmApplication.applicationDescLanguage',
          }
          ,
          {
            title:this.language['system.check.processing.status'],
            width: 200,
            ellipsis:true,
            align:"center",
            dataIndex: 'auditStatus',
            customRender: function (t, r, index) {
              switch (t){
                case "approving":
                  return store.getters.language['user.apply.untreated'];
                case "approved":
                  return store.getters.language['web.processed']+"("+store.getters.language['user.apply.passed']+")";
                case "rejected":
                  return store.getters.language['web.processed']+"("+store.getters.language['user.apply.under.review.passed']+")";
              }


            }
          }
          ,
          {
            title:this.language['common.creator'],
            width: 200,
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title:this.language['common.createTime'],
            width: 300,
            align:"center",
            dataIndex: 'createTime'
          },
          /*{
            title:this.language['common.auditor'],
            width: 200,
            align:"center",
            dataIndex: 'auditor'
          },
          {
            title:this.language['common.auditTime'],
            width: 300,
            align:"center",
            dataIndex: 'auditTime'
          },*/
          // {
          //   title:"最大时间",
          //   width: 300,
          //   align:"center",
          //   dataIndex: 'maxCreateTime',
          //   customRender: function (t, r, index) {
          //     return (t==r.createTime)+"";
          //
          //   }
          // },
          {
            title:this.language['system.bind']+this.language['column.status'],
            width: 200,
            align:"center",
            dataIndex: 'relationId',
            customRender: function (t, r, index) {

              if(t==null){
                return store.getters.language['system.check.unbound'];
              }else{
                return store.getters.language['system.check.bound'];
              }

            }

          }
          ,
          {
            title:this.language['common.action'],
            dataIndex: 'action',
            align:"center",
            width:250,
            fixed: 'right',
           scopedSlots: { customRender: 'action' }
          }
        ]
        }else{
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              fixed: 'left',
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            // {
            //   title:"id",
            //   align:"center",
            //   dataIndex: 'id',
            //   width: 180
            // },
            {
              title:this.language['system.user.name'],
              ellipsis:true,
              align:"center",
              dataIndex: 'sysUser.username',
              width: 180
            },
            {
              title:this.language['portal.personalWorkNo'],
              width: 180,
              align:"center",
              dataIndex: 'sysUser.workNo'

            },
            {
              title:this.language['portal.personalName'],
              width: 200,
              ellipsis:true,
              align:"center",
              dataIndex: 'sysUser.realname'
            },
            {
              title:this.language['system.apply.application'],
              ellipsis:true,
              width:200,
              align:"center",
              dataIndex: 'bmApplication.applicationNameLanguage'
            },
            {
              title:this.language['user.apply.description'],
              width: 200,
              ellipsis:true,
              align:"center",
              dataIndex: 'bmApplication.applicationDescLanguage',
            }
            ,
            {
              title:this.language['system.check.processing.status'],
              width: 200,
              ellipsis:true,
              align:"center",
              dataIndex: 'auditStatus',
              customRender: function (t, r, index) {
                switch (t){
                  case "approving":
                    return store.getters.language['user.apply.untreated'];
                  case "approved":
                    return store.getters.language['web.processed']+"("+store.getters.language['user.apply.passed']+")";
                  case "rejected":
                    return store.getters.language['web.processed']+"("+store.getters.language['user.apply.under.review.passed']+")";
                }


              }
            }
            ,
            {
              title:this.language['common.creator'],
              width: 200,
              align:"center",
              dataIndex: 'createBy'
            },
            {
              title:this.language['common.createTime'],
              width: 300,
              align:"center",
              dataIndex: 'createTime'
            },
            {
              title:this.language['common.auditorName'],
              width: 200,
              align:"center",
              dataIndex: 'auditorName'
            },
            {
              title:this.language['common.auditTime'],
              width: 300,
              align:"center",
              dataIndex: 'auditTime'
            },
            // {
            //   title:"最大时间",
            //   width: 300,
            //   align:"center",
            //   dataIndex: 'maxCreateTime',
            //   customRender: function (t, r, index) {
            //     return (t==r.createTime)+"";
            //
            //   }
            // },
            {
              title:this.language['system.bind']+this.language['column.status'],
              width: 200,
              align:"center",
              dataIndex: 'relationId',
              customRender: function (t, r, index) {

                if(t==null){
                  return store.getters.language['system.check.unbound'];
                }else{
                  return store.getters.language['system.check.bound'];
                }

              }

            }
            ,
            {
              title:this.language['common.action'],
              dataIndex: 'action',
              align:"center",
              width:250,
              fixed: 'right',
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      }
    }
  },
  methods: {
    resetQueryCondition(){
      //不知道为啥不行
     // this.$refs['queryForm'].resetFields()
      this.queryParam = {
        handleStatus:this.handleStatus,
      }
      this.loadData(1);
    },
    openModel(record,title,type){
      this.$refs.modalForm.edit(record,type);
      this.$refs.modalForm.title=title;
      this.$refs.modalForm.disableSubmit = true;
    },binding(record){
      this.openModel(record,this.language['system.bind'],"binding");
    },chooseRole(record){
      this.openModel(record,this.language['column.userRole.choose'],"chooseRole");
    },refuse(record){
      this.openModel(record,this.language['common.reject'],"refuse");
    },unbound(record){
      const that = this
      that.confirmLoading = true
      let formData = {};

      formData.applicationId =record.bmApplication.id;
      formData.userId = record.sysUser.id;
      formData.id = record.id;
      httpAction(that.url.unbound, formData, 'delete').then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          that.loadData(2);
        } else {
          that.$message.warning(res.message);
        }
      })
    },updateStatus(record){
      const that = this
      that.confirmLoading = true
      let formData = {};

      formData.id = record.id;
      formData.auditStatus = "approved";
      httpAction(that.url.updateStatus, formData, 'put').then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          that.loadData(2);
        } else {
          that.$message.warning(res.message);
        }
      })
    },
    initDictConfig(){
    },
    // 关闭模态框
    handleCancel() {
      this.previewVisible = false;
    },
    dataLoading(value){
      if(value==1){
        this.queryParam.handleStatus="0";
      }else{
        this.queryParam.handleStatus="1";
      }
      this.loadData(1);
    },
    getApplicationList(){
      httpAction("/sys/role/getSysBmApplicationDL", "", "get").then((res) => {
        if (res.success) {
          this.applicationList = res.result;
        }
      })
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less'
</style>